module.exports = __webpack_public_path__ + "static/media/ic-info.7ac53733.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic-info.svg
// module id = 728
// module chunks = 0